var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 199.92 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#linear-gradient);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(15.62)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.35,6.51c-22.27,13-30.23,41-18.55,65.76,2.08,4.41,4.58,8.62,6.89,12.94C-15.62,116.54-15.14,209.4,38.31,244.47c2.2-4,4.4-8,6.86-12.43-.81-.77-1.38-1.4-2-1.92A74.57,74.57,0,0,1,27.34,131.2C40,111.62,58.12,100.3,81,96.44A16.37,16.37,0,0,0,84.48,95a26.35,26.35,0,0,0-1.9-3.37A26.28,26.28,0,0,0,80,89.17c-9-9-16.88-18.78-20.1-31.51-3.55-14,1.41-28,12.86-36.23a33.22,33.22,0,0,1,37-.86c11.95,7.86,17.45,21.36,14.43,35.59S112.53,80.91,102.41,90.6c-1.34,1.29-2.2,3.07-3.6,5.07,32.77,5.25,55.58,21.8,65.6,52.33,11,33.39.77,61.57-25.66,84.26,2.35,4.23,4.61,8.3,7.06,12.74,24.14-18.44,37.56-42.36,37.95-72,.54-40.83-19.44-69.8-55.37-87.51,3.17-6.78,6.74-13,9.09-19.71,7.17-20.35,1.1-41.9-15-55.1a49.24,49.24,0,0,0-55.13-4.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1150.32,
    y1: 1729.34,
    x2: 1151.32,
    y2: 1729.34,
    gradientTransform: "matrix(0, -270, -270, 0, 423789.29, 282072.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04db04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#04da07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#04d70f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#03d21e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#02cc32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#01c34d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#00b86d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b478"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(15.62)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.19,109.14C53,113.29,29.27,137.88,26,166.61c-2.93,25.7,9,50.59,24.25,59.87l6.49-6.16c-28.85-24.29-24-62.68-3.43-82.15,21.82-20.7,56.49-20.64,77.58.38,10.5,10.47,16.31,23.14,16.56,37.92.31,17.7-6.82,32.3-20.72,43.83L134.3,227a68.4,68.4,0,0,0,17.91-80c-10.79-23.84-34.51-38.54-60.71-38.54a72.25,72.25,0,0,0-10.31.75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1154.26,
    y1: 1734.59,
    x2: 1155.26,
    y2: 1734.59,
    gradientTransform: "matrix(0, -118.58, -118.58, 0, 205794.32, 137097.51)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(15.62)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.4,155.31c-10.37,15.4-10.27,36.53.24,52,6.58,9.7,6.58,9.7,17.18,4.77.3-.14.58-.34.17-.1-3.88-7.62-8.39-14.52-11-22.08-4.63-13.32.5-27.44,11.79-35.84a32.15,32.15,0,0,1,36.89-1c11.64,7.68,17.67,21.72,13.55,35.2-2.53,8.26-7.31,15.83-11.15,23.88a19.17,19.17,0,0,1,4.52,2.05c3.36,2.47,5.58,1.49,8.18-1.35,10.16-11.06,13.93-24.2,11.87-38.72-2.75-19.45-16.47-33.64-35.35-37.81a43.41,43.41,0,0,0-9.39-1,45.44,45.44,0,0,0-37.48,20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1157.9,
    y1: 1739.5,
    x2: 1158.9,
    y2: 1739.5,
    gradientTransform: "matrix(0, -80.31, -80.31, 0, 139807.42, 93207.76)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 199.92,
    height: 270
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 38.7,
    y: 108.39,
    width: 141.56,
    height: 118.58
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 59.65,
    y: 135.29,
    width: 94.64,
    height: 81.75
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.9afb3df92af98d27c81afce79bc23b3d.svg";
export { ForwardRef as ReactComponent };